import GenerateSerialNumberForm from './generateSerialNumberForm.container';

export default GenerateSerialNumberForm;